(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if(window.Shopify&&window.Shopify.designMode) {} else {
    try{ if(sessionStorage.getItem('mrLeavesShown')) return; sessionStorage.setItem('mrLeavesShown','1'); }catch(e){}
  }
  var c=document.createElement('canvas'); c.className='mr-leaves'; c.setAttribute('aria-hidden','true'); document.body.appendChild(c);
  var g=c.getContext('2d'),W=0,H=0,dpr=Math.min(window.devicePixelRatio||1,2);
  function size(){W=window.innerWidth;H=window.innerHeight;c.width=W*dpr;c.height=H*dpr;g.setTransform(dpr,0,0,dpr,0,0);}
  size(); window.addEventListener('resize',size);
  var cols=['#7f9a55','#9db36b','#6e8a4d','#c49a4a','#b5703a'],N=W<700?12:22,L=[];
  for(var i=0;i<N;i++) L.push({x:Math.random()*W,y:-20-Math.random()*H*0.6,s:9+Math.random()*14,r:Math.random()*6.28,vr:(Math.random()-.5)*.04,
    vy:2.2+Math.random()*2.2,ph:Math.random()*6.28,sw:.6+Math.random()*1.2,col:cols[Math.floor(Math.random()*cols.length)],a:.45+Math.random()*.4});
  function leaf(l){g.save();g.translate(l.x,l.y);g.rotate(l.r);g.globalAlpha=l.a;g.fillStyle=l.col;
    g.beginPath();g.moveTo(0,-l.s);g.bezierCurveTo(l.s*.8,-l.s*.5,l.s*.8,l.s*.5,0,l.s);g.bezierCurveTo(-l.s*.8,l.s*.5,-l.s*.8,-l.s*.5,0,-l.s);g.fill();
    g.strokeStyle='rgba(255,255,255,.45)';g.lineWidth=1;g.beginPath();g.moveTo(0,-l.s*.9);g.lineTo(0,l.s*.9);g.stroke();g.restore();}
  function frame(){
    g.clearRect(0,0,W,H); var alive=0;
    L.forEach(function(l){ if(l.y>H+40) return; alive++; l.ph+=.03;l.x+=Math.sin(l.ph)*l.sw;l.y+=l.vy;l.r+=l.vr; leaf(l); });
    if(alive) requestAnimationFrame(frame); else c.remove();
  }
  frame();
})();